import { PiMegaphoneFill, PiChatTextFill, PiUsersFill, PiGearFill, PiChatsFill, PiCaretDoubleLeftFill, PiCaretDoubleRightFill, PiSignOutFill, PiBellFill, PiCaretDownFill, PiCaretUpFill, PiCaretLeftFill, PiListFill, PiCheckFatFill, PiMagnifyingGlassFill, PiPaperPlaneRightFill, PiPaperclipFill, PiSmileyFill, PiImageFill, PiStickerFill, PiPlusCircleFill, PiXCircleFill, PiCalendarFill, PiClockFill, PiVideoFill, PiUserCircleFill, PiImageSquareFill, PiLinkFill, PiCopyFill, PiDotsThreeVerticalFill, PiSparkleFill, PiQuestionFill } from 'react-icons/pi';
import type { IconType } from 'react-icons';
import type { IconName } from './iconPath';

const phosphorIcons = {
  megaphone: { component: PiMegaphoneFill, size: 24, color: 'currentColor' },
  menuLine: { component: PiChatTextFill, size: 24, color: 'currentColor' },
  menuUsers: { component: PiUsersFill, size: 24, color: 'currentColor' },
  menuSettings: { component: PiGearFill, size: 24, color: 'currentColor' },
  menuChat: { component: PiChatsFill, size: 24, color: 'currentColor' },
  chevronsLeft: { component: PiCaretDoubleLeftFill, size: 20, color: 'currentColor' },
  chevronsRight: { component: PiCaretDoubleRightFill, size: 20, color: 'currentColor' },
  signOut: { component: PiSignOutFill, size: 24, color: 'currentColor' },
  bell: { component: PiBellFill, size: 24, color: 'currentColor' },
  chevronDown: { component: PiCaretDownFill, size: 20, color: 'currentColor' },
  chevronUp: { component: PiCaretUpFill, size: 20, color: 'currentColor' },
  chevronLeft: { component: PiCaretLeftFill, size: 20, color: 'currentColor' },
  menuBars: { component: PiListFill, size: 20, color: 'currentColor' },
  check: { component: PiCheckFatFill, size: 16, color: 'currentColor' },
  checkBold: { component: PiCheckFatFill, size: 12, color: 'currentColor' },
  searchInput: { component: PiMagnifyingGlassFill, size: 20, color: '#9CA3AF' },
  sendMessage: { component: PiPaperPlaneRightFill, size: 24, color: 'currentColor' },
  attach: { component: PiPaperclipFill, size: 24, color: 'currentColor' },
  emoji: { component: PiSmileyFill, size: 24, color: 'currentColor' },
  image: { component: PiImageFill, size: 24, color: 'var(--color-neutral)' },
  sticker: { component: PiStickerFill, size: 24, color: 'var(--color-neutral)' },
  plus: { component: PiPlusCircleFill, size: 20, color: 'white' },
  close: { component: PiXCircleFill, size: 24, color: 'var(--color-neutral)' },
  calendar: { component: PiCalendarFill, size: 22, color: 'var(--color-neutral-400)' },
  clock: { component: PiClockFill, size: 20, color: 'var(--color-neutral-400)' },
  video: { component: PiVideoFill, size: 24, color: 'var(--color-neutral)' },
  userProfile: { component: PiUserCircleFill, size: 24, color: 'var(--color-neutral)' },
  imageUrl: { component: PiImageSquareFill, size: 24, color: 'var(--color-neutral)' },
  videoUrl: { component: PiVideoFill, size: 24, color: 'var(--color-neutral)' },
  link: { component: PiLinkFill, size: 24, color: 'currentColor' },
  copy: { component: PiCopyFill, size: 24, color: 'currentColor' },
  moreVertical: { component: PiDotsThreeVerticalFill, size: 16, color: 'currentColor' },
  aiStar: { component: PiSparkleFill, size: 20, color: 'currentColor' },
  help: { component: PiQuestionFill, size: 24, color: 'currentColor' },
} satisfies Record<IconName, { component: IconType; size: number; color: string }>;

export default phosphorIcons;
